export enum TemperatureStatusEnum {
    OK = 'ok',
    WARNING = 'warning',
    CRITICAL = 'critical',
}
